module.exports = __webpack_public_path__ + "static/media/bg.9860b9f6.jpg";